(function($) {
    'use strict';

    let $filter;
    let $headline;
    let $btnFind;

    document.addEventListener('DOMContentLoaded', () => {
        $filter = $('.filter');
        $headline = $('.headline');
        $btnFind = $('.filter__input-find');

        $.publish('reinit__search-results', [getCurrentResults()]);

        onFilterTypeChanged();
        onInput();
        onSearchClick();
        onChange();

        onMultilevelListItemIsSelected();
        onMultilevelListBreadcrumbsChanged();
        onMultilevelListIsLoaded();

        onFilterElementsDelete();
        onButtonFilterElementClearClick();

        if (isMobileApp()) {
            setTimeout(() => {
                if (!isShownResults() && !isShownSectionMedicineList() && !isShownMultilevelList()) {
                    $.publish('filter-changed');
                }
            }, 100);
        }
    });

    /**
     * Производит подписку на обработку события выбора вкладки
     *
     */
    function onFilterTypeChanged() {
        var subscribeEventName = 'filter-type:changed';

        $.unsubscribe(subscribeEventName);
        $.subscribe(subscribeEventName, (e, filterType) => {
            console.log('event-received: ' + subscribeEventName);

            hideAllFilterItems();

            if (filterElementIsSelected(filterType) || (filterType == 'list') || (filterType == 'archive')) {
                $.publish('filter-changed');
                return;
            }

            updateUrlParams();
            hideAllResults();

            $.publish('multilevel-list-breadcrumbs:get-data', [filterType]).promise()
                .done((data) => $.publish('multilevel-list:load', [filterType, data.link]))
                .fail(() => $.publish('multilevel-list:load', [filterType, '']));
        });
    }

    /**
     * Производит подписку на обработку события выбора элемента в многоуровневом списке
     *
     */
    function onMultilevelListItemIsSelected() {
        var subscribeEventName = 'multilevel-list:item-is-selected';

        $.subscribe(subscribeEventName, (e, itemData) => {
            console.log('event-received: ' + subscribeEventName);

            setFilterElement(itemData.multilevelListType, itemData);
        });
    }

    /**
     * Производит подписку на обработку события 'изменён breadcrumbs'
     *
     */
    function onMultilevelListBreadcrumbsChanged() {
        var subscribeEventName = 'multilevel-list-breadcrumbs:changed';

        $.subscribe(subscribeEventName, () => {
            console.log('event-received: ' + subscribeEventName);

            updateUrlParams();
        });
    }

    /**
     * Производит подписку на обработку события удалить элементы фильтра
     *
     */
    function onFilterElementsDelete() {
        var subscribeEventName = 'filter-elements-delete';

        $.unsubscribe(subscribeEventName);
        $.subscribe(subscribeEventName, (e, filterType) => {
            console.log('event-received: ' + subscribeEventName);

            if (!deleteFilterElement(filterType)) {
                return;
            }

            $.publish('multilevel-list:load', [filterType, '']);
        });
    }

    /**
     * Производит подписку на обработку события 'многоуровневый спискок загружен'
     *
     */
    function onMultilevelListIsLoaded() {
        var subscribeEventName = 'multilevel-list:loaded';

        $.subscribe(subscribeEventName, (e, listName, itemData, title) => {
            console.log('event-received: ' + subscribeEventName);
            setPageTitle(title);
        });
    }

    /**
     * Обработчик события: срабатывает при вводе текста в поле поиска
     *
     */
    function onInput() {
        let timer, delay = 250;

        $filter.off('input', '.filter__input-search');
        $filter.on('input', '.filter__input-search', function() {

            let $this = $(this);

            clearTimeout(timer);

            timer = setTimeout(function() {

                if ($this.val().trim().length > 1 || $this.val().trim().length == 0) {

                    $.publish('filter-changed');

                }

            }, delay);

            return false;

        });
    }

    /**
     * Обработчик события: отправка формы поиска
     *
     */
    function onSearchClick() {
        $filter.off('submit', 'form');
        $filter.on('submit', 'form', function() {

            $.publish('filter-changed');

            return false;

        });
    }

    /**
     * Производит подписку на обработку события изменения фильтра
     *
     */
    function onChange() {
        var subscribeEventName = 'filter-changed';

        $.unsubscribe(subscribeEventName);
        $.subscribe(subscribeEventName, (e, deferred) => {
            console.log('event-received: ' + subscribeEventName);

            let filterType = getCurrentFilterType();
            let searchedData = getCurrentSearchedData();
            let $form = $('form', $filter);
            let action = $form.attr('action');
            let data = $form.serialize();

            hideAllResults();
            hideAllFilterItems();

            $btnFind.addClass('is-searching');
            $('.results__loader').show();

            updateUrlParams();
            $.get(action, data, function(response) {
                deferred.resolve(response);

                $('.results__loader').hide();
                $btnFind.removeClass('is-searching');

                if (response.hasOwnProperty('data') && !!response.data.length) {
                    $headline.text('');
                    $headline.addClass('hidden');
                }

                if ((filterType !== getCurrentFilterType()) || (searchedData !== getCurrentSearchedData())) {
                    return;
                }

                hideAllResults();
                hideAllFilterItems();
                $filter.after(response.data);

                $.publish('reinit__search-results', [getResults(searchedData, filterType)]);

                setPageTitle(response.pageHeading);

                updateUrlParams();
            }, 'json');

        });
    }

    /**
     * Обработчик события: удаление элемента фильтра
     *
     */
    function onButtonFilterElementClearClick() {
        $filter.off('click', '.filter__filter-element__btn-delete, .filter__filter-element__btn-show-sub-categories');
        $filter.on('click', '.filter__filter-element__btn-delete, .filter__filter-element__btn-show-sub-categories', function(e) {
            e.preventDefault();

            let href = e.target.href;
            let filterType = getCurrentFilterType();
            if (!deleteFilterElement(filterType)) {
                return;
            }

            hideAllResults();
            $.publish('multilevel-list:load', [filterType, href]);
        });
    }

    function isMobileApp() {
        return document.body.classList.contains('is-mobile-app');
    }

    /**
     * Устанавливает значение фильтра
     *
     * @param {String} filterType Тип фильтра
     * @param {Object} data
     *
     */
    function setFilterElement(filterType, data) {
        if (!data) {
            return
        }

        let filterElement = getFilterElement(filterType);
        if (!filterElement) {
            return;
        }

        $.publish('multilevel-list-breadcrumbs:clear', [filterType]);

        filterElement.$element.attr('data-code', data.code);
        filterElement.$element.attr('data-parent-code', data.parentCode);

        filterElement.$value.val(data.code);
        filterElement.$title.text($.trim(data.name));

        filterElement.$btnDelete.attr('data-code', data.parentCode);
        filterElement.$btnDelete.attr('href', filterElement.$btnDelete.attr('data-template-href') + data.parentCode);

        filterElement.$btnShowSubCategories.attr('data-code', data.code);
        filterElement.$btnShowSubCategories.attr('href', filterElement.$btnShowSubCategories.attr('data-template-href') + data.code);
        if (data.isParent === '1') {
            filterElement.$btnShowSubCategories.addClass('show');
        } else {
            filterElement.$btnShowSubCategories.removeClass('show');
        }

        filterElement.$element.addClass('d-flex');

        $.publish('filter-changed');
    }

    /**
     * Удаление элемента фильтра
     *
     * @param {String} filterType Тип фильтра
     *
     */
    function deleteFilterElement(filterType) {
        let filterElement = getFilterElement(filterType);
        if (!filterElement) {
            return false;
        }

        filterElement.$element.attr('data-code', '');
        filterElement.$element.attr('data-parent-code', '');

        filterElement.$value.val('');
        filterElement.$title.text('');

        filterElement.$btnDelete.attr('data-code', '');
        filterElement.$btnDelete.attr('href', '');

        filterElement.$btnShowSubCategories.attr('data-code', '');
        filterElement.$btnShowSubCategories.attr('href', '');

        filterElement.$element.removeClass('d-flex');

        hideAllResults();

        updateUrlParams();

        return true;
    }

    /**
     * Возвращает текущий тип фильтра
     *
     * @return {String}
     */
    function getCurrentFilterType() {
        let searchedData = getCurrentSearchedData();
        let $tabContent = $filter.find('.filter__tab-content[data-searched-data="' + searchedData + '"]');
        let $input = $tabContent.find('input[name*="filter_type"]:checked');

        return $input.val();
    }

    /**
     * Возвращает тип данных
     *
     * @return {String}
     */
    function getCurrentSearchedData() {
        return $filter.find('input[name="searched_data"]').val();
    }

    /**
     * Возвращает объект содержащий ссылки на элементы фильтра
     *
     * @param {String} filterType Тип фильтра
     *
     * @return {Object}
     */
    function getFilterElement(filterType) {
        let $filterElement = $filter.find(`.filter__tab-content[data-searched-data="${getCurrentSearchedData()}"] .filter-type__state[data-filter-type="${filterType}"] .filter__filter-element`);
        if (!$filterElement.length) {
            return null;
        }

        return {
            $element: $filterElement,
            $value: $filterElement.find('.filter__filter-element__value'),
            $title: $filterElement.find('.filter__filter-element__title'),
            $btnDelete: $filterElement.find('.filter__filter-element__btn-delete'),
            $btnShowSubCategories: $filterElement.find('.filter__filter-element__btn-show-sub-categories'),
            code: $filterElement.attr('data-code'),
            parentCode: $filterElement.attr('data-parent-code')
        };
    }

    /**
     * Определяет выбран ли элемент фильтра в указанном типе фильтра
     *
     * @param {String} filterType Тип фильтра
     *
     * @return {Boolean}
     */
    function filterElementIsSelected(filterType) {
        let filterElement = getFilterElement(filterType);
        if (!filterElement || !filterElement.$value.length) {
            return false;
        }

        let value = parseInt(filterElement.$value.val(), 10);

        return !isNaN(value) && (value > 0);
    }

    /**
     * Возввращает get-параметры из текущего url
     *
     * @return {Object}
     */
    function getUrlParams() {
        let queryString = window.location.search;
        if (!queryString) {
            return {};
        }

        let arr = queryString.split('?');
        if (arr.length !== 2) {
            return {};
        }

        let params = {};
        let pairs = arr[1].split('&');
        for (let i = 0; i < pairs.length; i++) {
            let param = pairs[i].split('=');
            params[param[0]] = param[1];
        }

        return params;
    }

    /**
     * Устанавливает параметр в текущем url
     *
     * @param {String} paramName
     * @param {String} paramValue
     *
     */
    function setUrlParam(paramName, paramValue) {
        let queryString = '';
        let params = getUrlParams();

        if (!paramValue && (params[paramName] !== undefined)) {
            delete params[paramName];
        } else {
            params[paramName] = paramValue;
        }

        if (params) {
            for (let prop in params) {
                queryString += queryString ? '&' : '';
                queryString += prop + '=' + params[prop];
            }

            queryString = '?' + queryString;
        }

        window.history.replaceState({}, '', window.location.pathname + queryString);
    }

    /**
     * Обновляет url параметры
     *
     */
    function updateUrlParams() {
        let $form = $('form', $filter);
        let searchedData = getCurrentSearchedData();

        clearUrlParam();
        setUrlParam('searched_data', searchedData);
        setUrlParam('q', $form[0].elements['q'].value);
        setUrlParam('mq', $form[0].elements['mq'].value);
        setUrlParam('tq', $form[0].elements['tq'].value);

        let $tabContent = $filter.find('.filter__tab-content[data-searched-data="' + searchedData + '"]');
        if (!$tabContent.length) {
            return;
        }

        $tabContent.find('input[name]').each(function(index, input) {
            if (input.type === 'radio') {
                if (input.checked) {
                    setUrlParam(input.name, input.value);
                }
            } else {
                setUrlParam(input.name, input.value);
            }

        });
    }

    /**
     * Удаляет все параметры из url
     *
     */
    function clearUrlParam() {
        window.history.replaceState({}, '', window.location.pathname);
    }

    /**
     *
     *
     */
    function hideAllResults() {
        let $results = $('.results');
        if ($results.length) {
            $results.remove();
        }
    }

    function isShownResults() {
        return $('.results').length > 0;
    }

    function isShownSectionMedicineList() {
        return $('.section-medicine-list.show').length > 0;
    }

    function isShownMultilevelList() {
        return $('.multilevel-list.categories-mkb-list.show').length > 0;
    }

    /**
     * Скрывает все блоки filter-items
     *
     */
    function hideAllFilterItems() {
        $('.filter-items[data-filter-type]').removeClass('show');
    }

    /**
     * Возвращает текущий блок для отображения результатов поиска
     *
     *  @return {jQuery}
     */
    function getCurrentResults() {
        return getResults(getCurrentSearchedData(), getCurrentFilterType());
    }

    /**
     * Возвращает блок для отображения результатов поиска
     *
     *  @return {jQuery}
     */
    function getResults(searchedData, filterType) {
        return $(`.results[data-searched-data="${searchedData}"][data-filter-type="${filterType}"]`);
    }

    /**
     * Устанавливает заголовок страницы
     *
     *  @param {String} title
     */
    function setPageTitle(title) {
        if (!title) {
            return;
        }

        $('title', document).text(title);
    }

})(window.jQuery);